import script from "./user-list.vue?vue&type=script&setup=true&lang=js"
export * from "./user-list.vue?vue&type=script&setup=true&lang=js"

import "./user-list.vue?vue&type=style&index=0&id=799d09ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799d09ed"]])

export default __exports__